const questionTypeValues = [
  {title: 'multiSelect'},
  {title: 'textField'},
  {title: 'dateTime'},
  {title: 'select'}
];

export const questionTypes = questionTypeValues;
